import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import type { CommunityEssentialModel } from '@/models'
import { resetQueries } from '@/utils/api/reset-queries'

import { GET_ALL_FOLDERS_BASE_QUERY_KEY } from './get-all-folders'
import { GET_FOLDER_CONTENT_BASE_QUERY_KEY } from './get-folder-content'

export interface CreateCommunityEssentialRequest {
  name: string
  value?: string
  icon: string
  type: string
  buildingId: number
  position: number
  file?: File
  folderId?: number
}

const buildFormData = (data: CreateCommunityEssentialRequest): FormData => {
  const formData = new FormData()
  Object.entries(data).forEach(([key, val]) => {
    if (val !== undefined && val !== null) {
      formData.append(key, val instanceof File ? val : String(val))
    }
  })
  return formData
}

export const createCommunityEssential = async (data: CreateCommunityEssentialRequest) => {
  const response = await authAPI.post<CommunityEssentialModel>(
    '/building-essential',
    buildFormData(data),
    { headers: { 'Content-Type': 'multipart/form-data' } },
  )
  return response.data
}

export const useCreateCommunityEssential = () => {
  return useMutation({
    mutationFn: createCommunityEssential,
    onSuccess: () =>
      resetQueries([GET_FOLDER_CONTENT_BASE_QUERY_KEY], [GET_ALL_FOLDERS_BASE_QUERY_KEY]),
  })
}
